import ApiServiceV2 from '@/helpers/api.service.v2';

const APIV2 = new ApiServiceV2();

export const state = {
    ctrCards: {},
    ctrRows: [],
    ctrPageInfo: { total: 0 }
};

export const mutations = {
    SET_CTR_REPORT(state, message) {
        state.ctrCards = message.cards || {};
        state.ctrRows = message.records?.rows || [];
        state.ctrPageInfo = message.records?.pageInfo || { total: 0 };
    }
};

export const actions = {
    // POST /puhunan/campaign/ctr-report -> { from, to, categories, page, rows }
    getPuhunanCTRReport(context, params) {
        return new Promise((resolve, reject) => {
            APIV2.post('/puhunan/campaign/ctr-report', params)
                .then((response) => {
                    if (response.data.status === 'ok') {
                        context.commit('SET_CTR_REPORT', response.data.message);
                    }
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    // POST /puhunan/campaign/export -> emails the full filtered set as xlsx
    exportPuhunanCTRReport(_, params) {
        return new Promise((resolve, reject) => {
            APIV2.post('/puhunan/campaign/export', params)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export const getters = {
    ctrCards: (state) => state.ctrCards,
    ctrRows: (state) => state.ctrRows,
    ctrPageInfo: (state) => state.ctrPageInfo
};
